module.exports = __webpack_public_path__ + "media/images/banners/banner5-0cbd54a73affce16b0b63299c9da322b.jpg";